import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import {formatDate} from "../util/helpers";

export default function ChatDetail() {
    const [detail, setDetail] = useState();
    const [messages, setMessages] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const roomId = queryParams.get("id");

    const requestDetail = () => {
        return axios.get(`/admin/v1/chatrooms/${roomId}`).then((res) => setDetail(res.data));
    };
    const requestMessages = () => {
        return axios.get(`/admin/v1/chatrooms/${roomId}/messages`).then((res) => setMessages(res.data || []));
    };

    useEffect(() => {
        if (roomId) {
            requestDetail();
            requestMessages();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomId]);

    const displayChatStatus = (status) => {
        switch (status) {
            case "CREATED":
                return "대화중";
            case "PAID":
                return "결제완료";
            case "CONSULTING":
                return "상담중";
            case "COMPLETED":
                return "진행종료";
            case "REFUNDED":
                return "환불";
            default:
                return status;
        }
    };

    return (
            <div className="App">
                <div className="wrapper">
                    <div className="content-wrapper" style={{marginLeft: "0px"}}>
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-12">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item active">매칭관리 &gt; 매칭 목록 &gt; 상세</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: "bold"}}>매칭 정보</h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap">
                                                    {detail && (
                                                            <tbody>
                                                            <tr>
                                                                <th style={{width: "140px"}}>매칭ID</th>
                                                                <td>{detail.id}</td>
                                                                <th style={{width: "140px"}}>매칭 상태</th>
                                                                <td>{displayChatStatus(detail.status)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>게시글 제목</th>
                                                                <td colSpan={3} style={{textAlign: "left"}}>
                                                                    <a href={`/page/insights/detail?id=${detail.insightId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">
                                                                        {detail.insightTitle}
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>구매자ID</th>
                                                                <td>
                                                                    <a href={`/page/users/detail?userId=${detail.buyerId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">{detail.buyerId}</a>
                                                                </td>
                                                                <th>판매자ID</th>
                                                                <td>
                                                                    <a href={`/page/users/detail?userId=${detail.sellerId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">{detail.sellerId}</a>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>매칭 일시</th>
                                                                <td>{formatDate(detail.createdAt)}</td>
                                                                <th>결제 금액</th>
                                                                <td>{detail.price?.toLocaleString?.() || detail.price}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>결제 일시</th>
                                                                <td>{formatDate(detail.paymentAt)}</td>
                                                                <th>취소 일시</th>
                                                                <td>{formatDate(detail.canceledAt)}</td>
                                                            </tr>
                                                            <tr>

                                                                <th>세션 시작</th>
                                                                <td>{formatDate(detail.reservationAt)}</td>
                                                                <th>세션 종료</th>
                                                                <td>{formatDate(detail.endedAt)}</td>
                                                            </tr>
                                                            </tbody>
                                                    )}
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: "bold"}}>메시지</h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap"
                                                       style={{textAlign: "left"}}>
                                                    <thead>
                                                    <tr>
                                                        <th style={{width: 80}}>ID</th>
                                                        <th style={{width: 120}}>작성자ID</th>
                                                        <th style={{width: 180}}>작성일시</th>
                                                        <th>내용</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {messages && messages.map((m) => (
                                                            <tr key={m.id}>
                                                                <td>{m.id}</td>
                                                                <td>
                                                                    <a href={`/page/users/detail?userId=${m.memberId}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">{m.memberId}</a>
                                                                </td>
                                                                <td>{formatDate(m.createdAt)}</td>
                                                                <td style={{whiteSpace: "pre-wrap"}}>{m.body}</td>
                                                            </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{marginTop: "30px", marginBottom: "10px"}}>
                                    <div style={{margin: "0 auto"}}>
                                        <button
                                                type="button"
                                                className="btn btn-outline-dark"
                                                onClick={() => {
                                                    try {
                                                        // If opened in a new tab/window from the list, there is no meaningful back history
                                                        // Prefer closing the tab in that case
                                                        if (window.opener && window.history.length <= 1) {
                                                            window.close();
                                                            return;
                                                        }
                                                        // If there is history, go back
                                                        if (window.history.length > 1) {
                                                            navigate(-1);
                                                            return;
                                                        }
                                                    } catch (e) {
                                                        // ignore and fallback
                                                    }
                                                    // Fallback: go to chat list
                                                    navigate('/page/chat');
                                                }}
                                        >
                                            목록
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
    );
}
